import { useEffect, useState } from "react";
import api from "./api";


// Hook base: solo maneja la llamada a la API
export const useMutualCBO = () => {

 const getMutualPagadoyNoPago = async (params = {}) => {
  try {
    const { data } = await api.get("/ingresos-aseguradoras", {
      params: params});
    return data;
  } catch (error) {
    throw error.response?.data?.message || "Error al obtener datos";
  }
};

const getMutualFecha = async ({ mes, anio } = {}) => {
  try {
    const { data } = await api.get("/ingresos-aseguradoras-fecha", {
      params: { mes, anio }
    });
    return data;
  } catch (error) {
    throw error.response?.data?.message || "Error al obtener datos";
  }
};


 const getMutualEstado = async () => {
    try {
      const { data } = await api.get("/ingresos-aseguradoras-estados");
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener los deudores";
    }
  };
  
  const getMutual = async () => {
    try {
      const { data } = await api.get("/pacientes/achs-mutual");
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener los deudores";
    }
  };
  
   return { getMutual, getMutualPagadoyNoPago, getMutualFecha, getMutualEstado};

};


export const useGetMutual = () => {
  const { getMutual } = useMutualCBO();
  const [mutual, setMutual] = useState([]);
  const [errorMutual, setErrorMutual] = useState(null);
  const [loadingMutual, setLoadingMutual] = useState(true);

  const fetchGetMutual = async () => {
    setLoadingMutual(true);
    try {
      const data = await getMutual();
      setMutual(data);
      setErrorMutual(null);
    } catch (error) {
      setErrorMutual(error);
    } finally {
      setLoadingMutual(false);
    }
  };

  // Cargar al montar el componente
  useEffect(() => {
    fetchGetMutual();
  }, []);

  return {
    mutual,
    errorMutual,
    loadingMutual,
    refetchMutual: fetchGetMutual,
  };
};

export const useGetPrestacionServicio = () => {
  const { getMutualPagadoyNoPago } = useMutualCBO();
  const [Prestacion, setPrestacion] = useState([]);
  const [errorPrestacion, setErrorPrestacion] = useState(null);
  const [loadingPrestacion, setLoadingPrestacion] = useState(true);

  const fetchGetPrestacionGeneral = async (params = null) => {
    setLoadingPrestacion(true);
    try {

      const data = await getMutualPagadoyNoPago(params);

      setPrestacion(data);
      setErrorPrestacion(null);
    } catch (error) {
      setErrorPrestacion(error);
    } finally {
      setLoadingPrestacion(false);
    }
  };

  useEffect(() => {
    fetchGetPrestacionGeneral();
  }, []);

  return {
    Prestacion,
    errorPrestacion,
    loadingPrestacion,
    refetchPrestacion: fetchGetPrestacionGeneral,
  };
};

